import { OmniElement, OmniStyleElement, html, css } from 'omni-ui';

OmniStyleElement.register();

export class CampaignCardList extends OmniElement {
  static get properties() {
    return {
      rowData: { type: Array },
      nameKey: { type: String },
      urlKey: { type: String },
      controlTemplate: { attribute: false },
      nameTemplate: { attribute: false },
    };
  }

  static get styles() {
    return [
      super.styles,
      css`
        .omni ul {
          width: 100%;
          height: 100%;
          margin-top: 30px;
          display: flex;
          flex-flow: column nowrap;
        }

        .omni li {
          display: flex;
          flex-flow: row nowrap;
          align-items: center;
          background-color: rgb(rgb(var(--rgb-core-light)));
          border: 1px solid rgb(var(--rgb-core-medium-two));
          border-radius: 6px;
          height: 60px;
          padding-right: 24px;
        }

        .omni li:not(:last-child) {
          margin-bottom: 0.2857rem;
        }

        .omni li:hover {
          box-shadow: 0 17px 50px -10px rgba(var(--rgb-nav-one), 0.19);
          z-index: 1;
        }

        .omni .doc-name-wrapper {
          flex-grow: 1;
          padding: 0px 24px 0px 27px;
        }

        .omni span {
          line-height: 20px;
          font-size: 14px;
          font-weight: 600;
          font-stretch: normal;
          font-style: normal;
          line-height: 1.43;
          letter-spacing: 0.31px;
          text-transform: capitalize;
          text-overflow: ellipsis;
        }

        .omni .button {
          width: 38px;
          height: 32px;
          background: none;
          border: none;
          padding: 0px;
          object-fit: contain;
          padding: none;
        }
        .omni .button omni-icon:only-child {
          margin: 0px;
        }
      `,
    ];
  }

  _generateRows(items) {
    return items.map((element, index) => {
      let nameRendered = this.nameTemplate
        ? this.nameTemplate(element, index)
        : null;

      if (!nameRendered) {
        nameRendered = this.urlKey
          ? html`
              <a
                target="_blank"
                href=${element[this.urlKey]}
                rel="noopener noreferrer"
                ><span>${element[this.nameKey]}</span></a
              >
            `
          : html`<span>${element[this.nameKey]}</span>`;
      }

      return html`
        <li id=${index}>
          <div class="doc-name-wrapper">${nameRendered}</div>
          ${this.controlTemplate
            ? html` <div>${this.controlTemplate(element, index)}</div> `
            : null}
        </li>
      `;
    });
  }

  _renderRowList() {
    return html`
      ${this.rowData?.length
        ? html`
            <ul class="m-0 p-0">
              ${this._generateRows(this.rowData ?? [])}
            </ul>
          `
        : null}
    `;
  }

  render() {
    return html`<omni-style>${this._renderRowList()}</omni-style>`;
  }
}

OmniElement.register('campaign-card-list', CampaignCardList);
